<template>
        <b-card :no-body="true">
          <div class="text-center text-primary my-2" v-if="!models">
            <b-spinner class="align-middle"></b-spinner>
          </div>

          <div v-else>
              <b-card-body class="p-3 clearfix">
                    <i v-if="widget.icon.value" :class="widget.icon.value + ` ${widgetIconClass} p-3 font-2xl mr-3 float-left`"></i>
                    <div :class="`h5 text-${widget.icon.variant} mb-0 mt-2`">{{ value }}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">{{ widget.title }}</div>
              </b-card-body>
          </div>
        </b-card>
</template>

<script>
import safeEval from 'safe-eval'

export default {
    props: {
        widget: {
            type: Object
        }
    },
    data: function() {
        return {
            models: null
        }
    },
    computed: {
        widgetIconClass() {
            if (this.widget.icon.variant != "" && this.widget.icon.variant != "light") {
                if (this.widget.icon.variant === undefined) {
                    this.widget.icon.variant = this.widget.variant
                }

                return "text-white " + "bg-" + this.widget.icon.variant
            }
        },

        widgetClass() {
            if (this.widget.variant != "" && this.widget.variant != "light") {
                 return "text-white " + "bg-" + this.widget.variant
            }

            return ""
        },

        value() {
            let result = safeEval('(function() { ' + this.widget.formatter.code + ' })()', {
                models: this.models
            })

            return result
        },

        progressValue() {
            let result = safeEval('(function() { ' + this.widget.progressBar.formatter + ' })()', {
                models: this.models
            })

            return result
        }
    },

    created() {
        let payload = {
            uuid: this.widget.component,
            context: {
                limit: this.widget.formatter.limit,
                filter: this.widget.formatter.filter,
                filterOn: this.widget.formatter.filterOn,
                disabled: this.widget.formatter.disabled
            },
            cache: true
        }

        this.$store.dispatch('fetchComponentsModels', payload).then(data => {
            this.models = data.items
        }).catch(err => {
            // skip it
            this.models = []
        }) 
    }
}
</script>